import Joi from '@hapi/joi'

export const DailyFieldPerformanceReportSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select group`,
        "any.required": `Group required`
    }),
    estateID: Joi.number().invalid(0).required().label("Estate").messages({
        "any.invalid": `Select estate`,
        "any.required": `Estate required`
    }),
    divisionID: Joi.number().invalid(0).required().label("Division").messages({
        "any.invalid": `Select divisono`,
        "any.required": `Division required`
    }),
    fieldID: Joi.number().label("Field").messages({
    }),
    month: Joi.string().required().label("Month").messages({
        "any.invalid": `Select Month`,
        "any.required": `Month required`
    }),
}

